import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app">
      <section>

      
      <div className='app__Right'>
      <div className='app__Image'>
      </div>
      </div>
     

      <div className='app__Content'>
          <h2>Get <span>insights</span> that help your business grow.</h2>
          <p>Discover the benefits of data analytics and make better decisions regarding revenue, customer 
              experience, and overall efficiency.</p>

          <div className='app__Scores'>
          <div className='app__Score'>
          <h3>10k+</h3>
          <p> companies</p>
        </div>
        <div className='app__Score'>
          <h3>314</h3>
          <p> templates</p>
        </div>
        <div className='app__Score'>
          <h3>12M+</h3>
          <p> queries</p>
        </div>
      </div>
      </div>
     
      </section>
    </div>
  );
}

export default App;
